import dayjs from 'dayjs'

import { useLineChart } from '@/pages/ui/line-chart/use-line-chart'

import { cn } from '@/lib/utils'
import { renderVisaBulletinDate } from '@/lib/utils/visa-bulletin'

import type { VisaBulletinTrendMonthlySeriesItem } from '../../types'

export const VisaBulletinTrendChartTooltip: React.FC = () => {
  const { activeIndex, data } = useLineChart()

  if (activeIndex === null) {
    return null
  }

  const activeData = data[activeIndex] as VisaBulletinTrendMonthlySeriesItem | null

  if (!activeData) {
    return null
  }

  const { filingDate, finalActionDate, filingDateType, finalActionDateType } = activeData

  const isReversed = (filingDate ?? 0) > (finalActionDate ?? 0)

  return (
    <div className="flex flex-col gap-2">
      <div className="text-xs text-muted-foreground">{dayjs(activeData.date).format('MMM YYYY')}</div>
      <div className={cn('flex items-center gap-2', isReversed ? 'order-2' : 'order-1')}>
        <div className="h-[10px] w-[10px] rounded-full bg-[hsla(21,90%,48%,1)]" />
        <div className="text-[12px] font-medium text-foreground">
          {renderVisaBulletinDate(finalActionDate, finalActionDateType)}
        </div>
        <div className="text-xs text-[hsla(215,20%,65%,1)]">Final Action Date</div>
      </div>
      <div className={cn('flex items-center gap-2', isReversed ? 'order-1' : 'order-2')}>
        <div className="h-[10px] w-[10px] rounded-full bg-[hsla(224,64%,33%,1)]" />
        <div className="text-[12px] font-medium text-foreground">
          {renderVisaBulletinDate(filingDate, filingDateType)}
        </div>
        <div className="text-xs text-[hsla(215,20%,65%,1)]">Date for Filing</div>
      </div>
    </div>
  )
}
